import React, { useContext } from 'react';
import { style } from 'typestyle';
import { type MdiReactIconComponentType } from 'mdi-react';
import * as styles from './cards.styles';
import Column from '../../../core/components/column/column.component';
import { CrossAxisAlignment, MainAxisAlignment } from '../../../core/components/flex/flex.component';
import { IsMobileContext } from '../../../core/context/is-mobile';

interface Props {
  readonly title: string;
  readonly onClick?: () => void;
  readonly icon: MdiReactIconComponentType;
}

const DashboardItemCard = ({ title, icon, onClick }: Props): React.JSX.Element => {
  const isMobile = useContext(IsMobileContext);
  const Icon = icon;
  return (
    <Column
      className={style(styles.dashboardCard(onClick !== undefined, isMobile))}
      key={title}
      onClick={onClick}
      crossAxisAlignment={CrossAxisAlignment.Stretch}
      mainAxisAlignment={MainAxisAlignment.Stretch}
    >
      <Column crossAxisAlignment={CrossAxisAlignment.Center} mainAxisAlignment={MainAxisAlignment.Center}>
        <Icon className={style(styles.dashboardIcon)} />
        <span className={style(styles.cardHeader)}>{title}</span>
      </Column>
    </Column>
  );
};

export default DashboardItemCard;
